import searchNewsFacetsConfig from './search-news-facets.config';

export default {
  title: 'News',
  searchId: 'news',
  searchConfig: searchNewsFacetsConfig,
  resourcePath: '/news',
  facetsTitle: 'search#facets_title',
  totalResultsText: 'search#news_total',
  filtersTitle: 'search#filters_title',
  grid: 1,
  sort: {
    label: 'search#sort_title',
    options: [
      // {
      //   value: 'sort_title.keyword_ASC',
      //   label: 'search#sort_label_ciclo',
      //   selected: true,
      //   disabled: false
      // },
      {
        value: 'id_DESC',
        label: 'search#sort_data_desc',
        selected: true,
        disabled: true
      }
    ]
  },
  pagination: {
    limit: 5,
    options: [
      12,
      24,
      48
    ]
  },
  itemPreview: {
    classes: ''
  },
  fallback: {
    text: 'search#fallback_text',
    button: 'search#fallback_button'
  },
  ko: {
    text: 'search#ko_text',
    button: 'search#ko_button'
  }
};
